export default {"src":"/_next/static/media/calendar.90628348.svg","height":16,"width":12};